<template>
  <PortalPageShell
    icon="mdi-file-document-outline"
    title="Audit Report"
    :subtitle="$t('portal.auditReport')"
  >
    <AuditReport class="portal-page-fill" />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import AuditReport from '../components/AuditReport.vue';

export default {
  components: {
    PortalPageShell,
    AuditReport,
  },
};
</script>
